import { render, staticRenderFns } from "./HmnEducationalInstitution.vue?vue&type=template&id=fdda71c2&scoped=true"
import script from "./HmnEducationalInstitution.vue?vue&type=script&lang=js"
export * from "./HmnEducationalInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda71c2",
  null
  
)

export default component.exports